<mg-overlay-primary
  size="auto"
  [overlayTitle]="data.modalTitle">
  <ng-container *ngTemplateOutlet="mainTemplate"></ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</mg-overlay-primary>

<!-- Main Template -->
<ng-template #mainTemplate>
  <main
    *ngIf="formState$ | async as formState"
    class="modal-form tw-flex tw-flex-column tw-gap-4">
    <mg-text
      *ngIf="data.message"
      variant="body-sm"
      color="surface-alt">
      {{ data.message }}
    </mg-text>

    <section class="filters tw-grid tw-grid-cols-2 tw-column-gap-4 tw-row-gap-3">
      <div>
        <mg-form-date
          [control]="form.get('date')"
          [minDate]="MIN_DATE">
        </mg-form-date>
      </div>
      <div class="tw-relative">
        <mg-form-select
          appendTo="body"
          [placeholder]="'Period Name'"
          [floatingLabel]="true"
          [options]="periodOptions$ | async"
          [disabled]="formState === 'loading'"
          [loading]="formState === 'loading'"
          [control]="form.get('period')">
        </mg-form-select>
      </div>
    </section>
  </main>
</ng-template>

<!-- Footer Content Template -->
<ng-template #footerTemplate>
  <footer
    *ngIf="periodOptions$ | async as periodOptions"
    class="tw-flex tw-justify-between tw-items-center">
    <mg-btn
      variant="text"
      (pressed)="cancel()">
      {{ MESSAGES.PERIOD_SELECTOR_MODAL_CANCEL_BTN }}
    </mg-btn>
    <mg-btn
      variant="filled"
      [disabled]="(formState$ | async) === 'loading' || !form.get('period').valid"
      (pressed)="submit(form.get('period').value, periodOptions)">
      {{ MESSAGES.PERIOD_SELECTOR_MODAL_SUBMIT_BTN }}
    </mg-btn>
  </footer>
</ng-template>
